export default "__VITE_ASSET__54001cd9__"